import { classNames } from 'primereact/utils';
import { BundleInteractionButton, ViewPageNavigationInfo } from '@/ui/pages/BundlePage/components';
import { useBundleInteractionExtractTo } from '../hooks';

export const NavigationAndInteractionControlPanel = () => {
  const { showCategoriesPopup } = useBundleInteractionExtractTo();

  return (
    <div className={classNames('absolute end-6 bottom-6 z-10', 'flex flex-col gap-2')}>
      {!showCategoriesPopup && <ViewPageNavigationInfo />}
      <BundleInteractionButton />
    </div>
  );
};
